// <copyright>Copyright (c) Microsoft Corporation. All rights reserved.</copyright>

export function originMatches(origin: string, originPattern: string): boolean {
    if (originPattern === "*") {
        return true;
    }

    if (originPattern.startsWith("https://*.") && origin.startsWith("https://")) {
        // https://*.<pattern> is a pattern. We need to check if origin matches this pattern, which requires checking
        // that they end with the same domain segments. We need to include the "." from the pattern to avoid cases where
        // the first domain segment is a substring of the other one (e.g. avoid making https://a.onetwo.com match
        // https://*.two.com)
        // "https://" is 8 characters
        const domainStartIndex: number = 8;

        // Skip the * in the pattern when comparing the domains.
        const domainPattern: string = originPattern.substring(domainStartIndex + 1);
        const originDomain: string = origin.substring(domainStartIndex);

        return originDomain.endsWith(domainPattern);
    }

    return origin === originPattern;
}
